<template>
  <div class="donate-carousel" v-if="ready">
    <h2>Choose your pack</h2>

    <!-- Radio button -->
    <div class="wwf-radio-bttns" v-if="packages.length > 1">
      <label :for="'package-' + item.code" v-for="(item, index) in packages">
        {{ item.display }}
        <input
          type="radio"
          v-validate="'required'"
          v-model="donation.packagecode"
          name="package"
          :value="item.code"
          :checked="index == 0 ? 'checked' : ''"
          :id="'package-' + item.code"
          @change="radioChanged(index)"
        />
        <span class="wwf-radio"></span>
      </label>
      <span class="wwf-alert">
        <p v-if="errors.first('package')">Please choose your pack</p>
      </span>
    </div>

    <!-- Carousel -->
    <VueSlickCarousel
      ref="adoptionCarousel"
      :infinite="false"
      :arrows="false"
      @afterChange="updateSelectedPackage"
    >
      <div v-for="item in packages" :key="item.code">
        <div class="slide">
          <div
            class="product-pack"
            :style="'background-image: url(' + item.pack.image + ')'"
          ></div>
          <div
            class="product-toy"
            v-if="item.toy"
            :style="'background-image: url(' + item.toy.image + ')'"
          ></div>
        </div>
      </div>
    </VueSlickCarousel>

    <div class="product-label">
      <p class="title">{{ selectedPackage.display }}</p>
      <p>
        {{ selectedPackage.pack.text }}
        <span v-if="selectedPackage.toy">{{ selectedPackage.toy.text }}</span>
      </p>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";

export default {
  name: "Carousel",
  components: {
    VueSlickCarousel,
  },

  data() {
    return {
      slideIndex: 0,
    };
  },
  computed: {
    ready() {
      return !!this.packages && this.packages.length > 0;
    },
    selectedPackage() {
      return this.packages[this.slideIndex];
    },
    ...mapState({
      donation: (state) => state.donation.donation,
      packages: (state) => state.product.packagesProduct,
    }),
  },

  methods: {
    updateSelectedPackage(slideIndex) {
      this.slideIndex = slideIndex;
      this.donation.packagecode = this.packages[slideIndex].code;
    },
    radioChanged(index) {
      this.$refs.adoptionCarousel.goTo(index);
      this.updateSelectedPackage(index);
    }
  },
};
</script>

<style scoped>
.donate-carousel {
  position: relative;
  margin-bottom: 2rem;
}
.slide {
  position: relative;
  height: 0;
  padding-top: 65%;
}
.product-pack {
  z-index: 1;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.product-toy {
  z-index: 2;
  position: absolute;
  right: -5%;
  bottom: 5%;
  width: 40%;
  height: 55%;
  background-size: 90% auto;
  background-repeat: no-repeat;
}
.product-label {
  position: relative;
  padding: 1.5rem;
  color: var(--wwfWhite);
  text-align: center;
  background: var(--wwfBlack);
}
.product-label .title {
  margin-bottom: 0.3rem;
  font-weight: 700;
}

.product-label p {
  color: var(--wwfWhite);
}

.product-label::before {
  content: "";
  z-index: 1;
  position: absolute;
  top: -12px;
  left: calc(50% - 12.5px);
  width: 25px;
  height: 25px;
  background-color: var(--wwfBlack);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// AdoptionCarousel.vue?15313bcc